import { render, staticRenderFns } from "./kendo-chart.vue?vue&type=template&id=89e45e96&scoped=true"
import script from "./kendo-chart.vue?vue&type=script&lang=js"
export * from "./kendo-chart.vue?vue&type=script&lang=js"
import style0 from "./kendo-chart.vue?vue&type=style&index=0&id=89e45e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e45e96",
  null
  
)

export default component.exports